const CascadeIcon = ({ color = '#314158', width = '16px', height = '16px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height} color={color} fill="none">
			<defs />
			<path
				fill={color}
				d="M4.5,1.75 L19.5,1.75 C21.019,1.75 22.25,2.981 22.25,4.5 L22.25,19.5 C22.25,21.019 21.019,22.25 19.5,22.25 L4.5,22.25 C2.981,22.25 1.75,21.019 1.75,19.5 L1.75,4.5 C1.75,2.981 2.981,1.75 4.5,1.75 Z M3.25,4.5 L3.25,19.5 C3.25,20.19 3.81,20.75 4.5,20.75 L19.5,20.75 C20.19,20.75 20.75,20.19 20.75,19.5 L20.75,4.5 C20.75,3.81 20.19,3.25 19.5,3.25 L4.5,3.25 C3.81,3.25 3.25,3.81 3.25,4.5 Z M9.53,8.47 L14.25,13.189 L14.25,11 C14.25,10.586 14.586,10.25 15,10.25 C15.414,10.25 15.75,10.586 15.75,11 L15.75,15 C15.75,15.414 15.414,15.75 15,15.75 L11,15.75 C10.586,15.75 10.25,15.414 10.25,15 C10.25,14.586 10.586,14.25 11,14.25 L13.189,14.25 L8.47,9.53 C8.177,9.237 8.177,8.763 8.47,8.47 C8.763,8.177 9.237,8.177 9.53,8.47 Z"
			/>
		</svg>
	);
};

export default CascadeIcon;
